export const months = [
	{ label: "January", value: "1", id: "1" },
	{ label: "February", value: "2", id: "2" },
	{ label: "March", value: "3", id: "3" },
	{ label: "April", value: "4", id: "4" },
	{ label: "May", value: "5", id: "5" },
	{ label: "June", value: "6", id: "6" },
	{ label: "July", value: "7", id: "7" },
	{ label: "August", value: "8", id: "8" },
	{ label: "September", value: "9", id: "9" },
	{ label: "October", value: "10", id: "10" },
	{ label: "November", value: "11", id: "11" },
	{ label: "December", value: "12", id: "12" },
];

export const monthsString = [
	"_",
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

export const runTimeList = [
	{ value: 0, label: "12:00 AM" },
	{ value: 1, label: "01:00 AM" },
	{ value: 2, label: "02:00 AM" },
	{ value: 3, label: "03:00 AM" },
	{ value: 4, label: "04:00 AM" },
	{ value: 5, label: "05:00 AM" },
	{ value: 6, label: "06:00 AM" },
	{ value: 7, label: "07:00 AM" },
	{ value: 8, label: "08:00 AM" },
	{ value: 9, label: "09:00 AM" },
	{ value: 10, label: "10:00 AM" },
	{ value: 11, label: "11:00 AM" },
	{ value: 12, label: "12:00 PM" },
	{ value: 13, label: "01:00 PM" },
	{ value: 14, label: "02:00 PM" },
	{ value: 15, label: "03:00 PM" },
	{ value: 16, label: "04:00 PM" },
	{ value: 17, label: "05:00 PM" },
	{ value: 18, label: "06:00 PM" },
	{ value: 19, label: "07:00 PM" },
	{ value: 20, label: "08:00 PM" },
	{ value: 21, label: "09:00 PM" },
	{ value: 22, label: "10:00 PM" },
	{ value: 23, label: "11:00 PM" },
];
